import { react2angular } from 'react2angular';

import { featureEnabled } from 'utils';
import AppointmentUpdateTooltip from './AppointmentUpdateTooltip';

angular
  .module('bb.external')
  .component('bbAppointmentUpdates', {
    bindings: {},
    controller: AppointmentUpdates,
    controllerAs: 'vm',
    template: require('./appointment_updates.html'),
  })
  .component('bbAppointmentTooltip', react2angular(AppointmentUpdateTooltip));

AppointmentUpdates.$inject = [
  '$location',
  '$routeParams',
  '$q',
  'listingNotificationSettings',
  'ErrorService',
  'ExternalService',
  'ExternalAuth',
  'ToastService',
];

function AppointmentUpdates(
  $location,
  $routeParams,
  $q,
  listingNotificationSettings,
  ErrorService,
  ExternalService,
  ExternalAuth,
  ToastService,
) {
  const vm = this;
  vm.auth = ExternalAuth.auth;
  const { retsId, dashboardId } = $routeParams;
  vm.newNotifications = {};
  vm.$onInit = function () {
    if (!featureEnabled('propertyNotificationsRevampFeature', 1)) {
      if (!vm.auth.hasBookedShowing) {
        vm.back();
      }
    }
    let promise;
    if (retsId) {
      promise = retsInit();
    } else if (dashboardId) {
      promise = dashInit();
    }

    promise
      .catch(function (err) {
        ErrorService.toastyHTTPErr(err);
      })
      .finally(function () {
        vm.dataLoaded = true;
      });
  };

  function retsInit() {
    return listingNotificationSettings
      .get(retsId)
      .then(function (notifications) {
        vm.newNotifications.registeredOffers = notifications.registeredOffers;
        vm.newNotifications.propertyAnnouncements =
          notifications.propertyAnnouncements;
        vm.newNotifications.feedbackReminders = notifications.feedbackReminders;
        vm.newNotifications.priceChanges = notifications.priceChanges;
        vm.newNotifications.statusChanges = notifications.statusChanges;

        vm.listing = vm.auth.listing;
      });
  }

  function dashInit() {
    return listingNotificationSettings
      .getDash(dashboardId)
      .then(function (notifications) {
        vm.newNotifications.registeredOffers = notifications.registeredOffers;
        vm.newNotifications.feedbackReminders = notifications.feedbackReminders;
        vm.newNotifications.propertyAnnouncements =
          notifications.propertyAnnouncements;
        vm.newNotifications.priceChanges = notifications.priceChanges;
        vm.newNotifications.statusChanges = notifications.statusChanges;

        vm.listing = vm.auth.listing;
      });
  }

  vm.back = function () {
    if (retsId) {
      $location.path(`/rets/${retsId}/appointments/book`);
    } else {
      $location.path(`/dash/${dashboardId}/appointments`);
    }
  };

  vm.saveNotifications = () => {
    vm.dataLoaded = false;
    let promise;
    if (retsId) {
      promise = listingNotificationSettings.save(retsId, vm.newNotifications);
    } else if (dashboardId) {
      promise = listingNotificationSettings.saveDash(
        dashboardId,
        vm.newNotifications,
      );
    }

    promise
      .then(function () {
        ToastService.add({
          message:
            'Notification preferences on the listing have been updated successfully',
          type: 'success',
        });
      })
      .catch(function (err) {
        ErrorService.toastyHTTPErr(err);
      })
      .finally(function () {
        vm.dataLoaded = true;
      });
  };

  vm.hasOffersFeature = () => vm.auth.hasFeature('OFFERS');

  vm.hasPropertyNotificationsRevamp = phase => {
    return featureEnabled('propertyNotificationsRevampFeature', phase);
  };

  vm.titleText = featureEnabled('propertyNotificationsRevampFeature', 1)
    ? 'Notifications'
    : 'Updates';
}

export {};
